import React, { useEffect, useState } from 'react';
import { get, post } from '../utils/api';

const money = value =>
  '₦' +
  Number(value || 0).toLocaleString('en-NG', {
    minimumFractionDigits:2,
    maximumFractionDigits:2
  });

const dateTime = value =>
  value
    ? new Date(value).toLocaleString('en-NG')
    : '—';

// INVENTORY FINISHED-GOODS RELEASE QUEUE
export default function FinishedGoodsReleaseQueue() {
  const [items, setItems] = useState([]);
  const [notes, setNotes] = useState({});
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await get(
        '/deliveries/inventory-release-queue'
      );

      setItems(response.data || []);
    } catch (loadError) {
      setError(
        loadError.message ||
        'Finished Goods Release Queue could not be loaded.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const releasePackage = async item => {
    if (
      !window.confirm(
        'Confirm that you have physically verified ' +
        'these finished goods and are releasing them ' +
        'to the Delivery Desk?'
      )
    ) {
      return;
    }

    setBusyId(item.id);

    try {
      const response = await post(
        '/deliveries/' +
          item.id +
          '/handover/request',
        {
          inventory_notes:
            String(notes[item.id] || '').trim()
        }
      );

      alert(
        response.message ||
        'Package released to the Delivery Desk.'
      );

      await load();
    } catch (releaseError) {
      alert(
        releaseError.message ||
        'The package could not be released.'
      );
    } finally {
      setBusyId(null);
    }
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  return (
    <div>
      <div className="flex-between mb-lg">
        <div>
          <h3 style={{margin:0}}>
            Finished Goods Release Queue
          </h3>

          <div
            style={{
              fontSize:12,
              color:'#776A60',
              marginTop:5
            }}
          >
            Verify the finished goods physically before
            releasing them to Progress at the Delivery
            Desk.
          </div>
        </div>

        <button
          type="button"
          className="btn btn-outline btn-sm"
          onClick={load}
        >
          Refresh Queue
        </button>
      </div>

      {error && (
        <div
          style={{
            background:'#FDEAEA',
            border:'1px solid #F5B8B8',
            color:'#8F2E24',
            borderRadius:8,
            padding:12,
            marginBottom:14
          }}
        >
          {error}
        </div>
      )}

      {!error && items.length === 0 && (
        <div
          style={{
            background:'#E8F5EB',
            border:'1px solid #B9DEC1',
            color:'#2E6B3A',
            borderRadius:10,
            padding:18
          }}
        >
          No finished-goods release request is waiting.
        </div>
      )}

      <div style={{display:'grid',gap:14}}>
        {items.map(item => (
          <div
            key={item.id}
            style={{
              background:'#fff',
              border:'1px solid #D8CFBF',
              borderRadius:12,
              padding:16
            }}
          >
            <div
              style={{
                display:'flex',
                justifyContent:'space-between',
                gap:12,
                flexWrap:'wrap',
                marginBottom:12
              }}
            >
              <div>
                <div
                  style={{
                    fontWeight:800,
                    color:'#3B2A21'
                  }}
                >
                  {item.job_number ||
                    item.customer_name ||
                    'Ready Customer Order'}
                </div>

                <div
                  style={{
                    fontSize:12,
                    color:'#776A60',
                    marginTop:3
                  }}
                >
                  Customer: {item.customer_name || '—'}
                </div>
              </div>

              <div
                style={{
                  background:'#E7F5FF',
                  color:'#3B5BDB',
                  borderRadius:999,
                  padding:'5px 10px',
                  fontSize:11,
                  fontWeight:700
                }}
              >
                Release Requested
              </div>
            </div>

            <div
              style={{
                display:'grid',
                gridTemplateColumns:
                  'repeat(auto-fit,minmax(160px,1fr))',
                gap:10,
                marginBottom:12,
                fontSize:12
              }}
            >
              <div>
                <strong>Invoice:</strong>{' '}
                {item.invoice_number || '—'}
              </div>

              <div>
                <strong>Balance:</strong>{' '}
                {money(item.live_balance_due)}
              </div>

              <div>
                <strong>Job Order:</strong>{' '}
                {item.job_order_status || '—'}
              </div>

              <div>
                <strong>Requested by:</strong>{' '}
                {item.requested_by_name || '—'}
              </div>

              <div>
                <strong>Requested:</strong>{' '}
                {dateTime(
                  item.inventory_release_requested_at
                )}
              </div>
            </div>

            {item.inventory_release_request_notes && (
              <div
                style={{
                  background:'#F9F8F5',
                  borderRadius:8,
                  padding:10,
                  marginBottom:12,
                  fontSize:12
                }}
              >
                <strong>Front Desk note:</strong>{' '}
                {item.inventory_release_request_notes}
              </div>
            )}

            <div className="form-group">
              <label className="form-label">
                Inventory Verification or Release Notes
              </label>

              <textarea
                className="form-control"
                rows={2}
                value={notes[item.id] || ''}
                onChange={event =>
                  setNotes(current => ({
                    ...current,
                    [item.id]:event.target.value
                  }))
                }
                placeholder="Package count, condition or handover note"
              />
            </div>

            <button
              type="button"
              className="btn btn-primary"
              disabled={busyId === item.id}
              onClick={() => releasePackage(item)}
            >
              {busyId === item.id
                ? 'Releasing...'
                : 'Verify and Release to Delivery Desk'}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
